import script from "./UploadReportImages.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadReportImages.vue?vue&type=script&setup=true&lang=js"

import "./UploadReportImages.vue?vue&type=style&index=0&id=77692286&lang=css"

const __exports__ = script;

export default __exports__